/* eslint-disable jsx-a11y/anchor-is-valid */
  import Styles from "./styles.module.scss";
  import FormHead from "../../components/headings/FromHead";
  import { Icon } from "@iconify/react";
  import {useState } from "react";
  import AddAwards from "../../modal/addAwards";
  import Table from "../../components/table";
  
  
  function AwardsCertifications(props: any) {
    
    const { v4: uuidv4 } = require("uuid")
    const [addAward, setAddAward] = useState<boolean>(false) 

    const addAwards = (data: any) => {
      if(data.type === 1){
        let body = {
          "action": "add",
          "section": "certification",
          "customerId": props.customerId,
          "customerMetadata": {
            "certifications": [
              {
                "certificationId": uuidv4(),
                "certificationNumber": data.number,
                "certificationName": data.name,
                "logo": data.logo !== undefined ? data.logo : " ",
                "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
              }
            ]
          }
        }
        props.updateAwardCertifications(body)
        setAddAward(false)
      }
      if(data.type === 2){
        let body = {
          "action": "add",
          "section": "award",
          "customerId": props.customerId,
          "customerMetadata": {
            "awards": [
              {
                "awardId": uuidv4(),
                "awardNumber": data.number,
                "awardName": data.name,
                "logo": data.logo !== undefined ? data.logo : " ",
                "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
              }
            ]
          }
        }
        props.updateAwardCertifications(body)
        setAddAward(false)
      }
    }
 
    return (
      <div >
        <div className="form-group">
          <figure className={Styles.uploadPicWrap}>
            {props.defImage ? <img alt="" src={props.defImage} /> :
            <span className={Styles.noPicWrap}>{props.companyName && props.companyName[0]}{props.companyName && props.companyName[1]}</span>}   
          </figure>
        </div>
        <div className={Styles.subHeadWrap}>
          <FormHead>Awards & Certifications</FormHead>
          <a
            className={Styles.addWorkHistory}
            onClick={() => setAddAward(true)}
          >
            <Icon icon="fluent:add-16-filled" />
            Add new Awards/Certificates
          </a>
        </div>
        <div className="tableStyle no-min-height no-top-padd">
          <Table  data={[...props.awardsData, ...props.certificationData]}  type={'awardsCertifications'} updateAwardCertifications={props.updateAwardCertifications} customerId={props.customerId}/>
        </div>
        {addAward && <AddAwards onClose={() => setAddAward(false)} clickHandler={addAwards}/>}
      </div>
    )
  }
  export default AwardsCertifications;
  